export const NODE_TYPES = {
  START_NODE: '1',
  VIDEO_NODE: '2',
  END_NODE: '3'
};
